var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRteItalic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "10px",
    viewBox: "0 0 8 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rich-text-updates",
    transform: "translate(-523.000000, -116.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-italic",
    transform: "translate(523.000000, 116.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.48314607,10 L0,10 L0.224719101,9.13636364 C0.359550562,9.13636364 0.584269663,9.09090909 0.808988764,9.09090909 C1.07865169,9.09090909 1.21348315,9.04545455 1.34831461,9 C1.52808989,8.90909091 1.66292135,8.81818182 1.75280899,8.72727273 C1.84269663,8.59090909 1.93258427,8.45454545 1.97752809,8.27272727 L3.59550562,1.86363636 C3.64044944,1.68181818 3.64044944,1.54545455 3.59550562,1.45454545 C3.5505618,1.31818182 3.46067416,1.22727273 3.3258427,1.13636364 C3.23595506,1.09090909 3.05617978,1.04545455 2.87640449,1 C2.65168539,0.954545455 2.42696629,0.909090909 2.29213483,0.909090909 L2.51685393,0 L8,0 L7.7752809,0.909090909 C7.64044944,0.909090909 7.28089888,0.954545455 7.05617978,0.954545455 C6.83146067,1 6.65168539,1 6.51685393,1.04545455 C6.33707865,1.09090909 6.15730337,1.18181818 6.06741573,1.31818182 C5.97752809,1.45454545 5.88764045,1.59090909 5.88764045,1.77272727 L4.26966292,8.18181818 C4.2247191,8.36363636 4.2247191,8.5 4.26966292,8.63636364 C4.31460674,8.77272727 4.40449438,8.86363636 4.53932584,8.90909091 C4.62921348,8.95454545 4.76404494,9 4.98876404,9.04545455 C5.21348315,9.09090909 5.57303371,9.09090909 5.70786517,9.13636364 L5.48314607,10 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRteItalic);
export default __webpack_public_path__ + "static/media/icon-rte-italic.827b34b120681f4167822a0fd1e17af2.svg";
export { ForwardRef as ReactComponent };